export default __webpack_public_path__ + "static/media/img_step_6.5876f0cd.svg";